import { LANGUAGES, ENGLISH_LANG_SHORT } from 'configs/constants';

export const getLocale = (language) => {
  const defaultLanguage = LANGUAGES.find((lang) => lang.code === ENGLISH_LANG_SHORT)?.value;
  const selectedLanguage = LANGUAGES.find((lang) => lang.code === language)?.value;

  return selectedLanguage || defaultLanguage;
};
